var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { getTranslate } from 'react-localize-redux';
import classNames from 'classnames';
import { Map, List as ImuList } from 'immutable';
// - Material UI
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import SvgAdd from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import { grey } from '@material-ui/core/colors';
// - Import app components
import UserAvatar from 'components/userAvatar';
// - Import API
import StringAPI from 'api/StringAPI';
import './userbox.css';
// - Import actions
import * as circleActions from 'store/actions/circleActions';
import { ServerRequestType } from 'constants/serverRequestType';
import { ServerRequestStatusType } from 'store/actions/serverRequestStatusType';
var styles = function (theme) {
    var _a;
    return ({
        root: {
            width: '100%',
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper
        },
        paper: {
            height: 200,
            width: window.outerWidth > 500 ? 50 : 75,
            margin: 10,
            textAlign: 'center',
            minWidth: '150px',
            maxWidth: '200px',
            backgroundColor: '#fff',
            borderRadius: 0,
        },
        dialogContent: {
            paddingTop: '5px',
            padding: '0px 5px 5px 5px'
        },
        circleName: {
            fontSize: '1rem',
        },
        space: {
            height: 20
        },
        fullPageXs: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
                height: '100%',
                margin: 0,
                overflowY: 'auto'
            },
            _a)
    });
};
/**
 * Create component class
 */
var UserBoxComponent = /** @class */ (function (_super) {
    __extends(UserBoxComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function UserBoxComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            followButton: {
                position: 'absolute',
                bottom: '30px',
                left: 0,
                right: 0,
                color: 'red',
            },
            dialog: {
                width: '',
                maxWidth: '280px',
                borderRadius: '4px'
            }
        };
        /**
         * Handle follow user
         */
        _this.handleDoneAddCircle = function () {
            var _a = _this.props, userId = _a.userId, user = _a.user, addUserToCircle = _a.addUserToCircle, selectedCircles = _a.selectedCircles, deleteFollowingUser = _a.deleteFollowingUser, avatar = _a.avatar, fullName = _a.fullName;
            var disabledDoneCircles = _this.state.disabledDoneCircles;
            if (!disabledDoneCircles) {
                if (selectedCircles.count() > 0) {
                    addUserToCircle(selectedCircles, { avatar: avatar, userId: userId, fullName: fullName });
                }
                else {
                    deleteFollowingUser(userId);
                }
            }
        };
        _this.capitalize = function (str) {
            //  const {post} = this.props
            //  post.get('ownerDisplayName')
            //  var string = post.get('ownerDisplayName')
            str = str.toLowerCase()
                .split(' ')
                .map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1); })
                .join(' ');
            return str;
        };
        /**
         * Handle follow user
         */
        _this.onFollowUser = function (event) {
            // This prevents ghost click
            event.preventDefault();
            var _a = _this.props, isFollowed = _a.isFollowed, followUser = _a.followUser, followingCircle = _a.followingCircle, userId = _a.userId, user = _a.user, followRequest = _a.followRequest, avatar = _a.avatar, fullName = _a.fullName;
            if (followRequest && followRequest.status === ServerRequestStatusType.Sent) {
                return;
            }
            if (!isFollowed) {
                followUser(followingCircle.get('id'), { avatar: avatar, userId: userId, fullName: fullName });
            }
            else {
                _this.onRequestOpenAddCircle();
            }
        };
        /**
         * Handle request close for add circle box
         */
        _this.onRequestCloseAddCircle = function () {
            var _a = _this.props, setSelectedCircles = _a.setSelectedCircles, userId = _a.userId, userBelongCircles = _a.userBelongCircles, closeSelectCircles = _a.closeSelectCircles;
            setSelectedCircles(userId, userBelongCircles);
            closeSelectCircles(userId);
            _this.setState({
                circleName: "",
                disabledCreateCircle: true,
                disabledAddToCircle: true,
                disabledDoneCircles: true
            });
        };
        /**
         * Handle request open for add circle box
         */
        _this.onRequestOpenAddCircle = function () {
            var _a = _this.props, openSelectCircles = _a.openSelectCircles, userId = _a.userId;
            openSelectCircles(userId);
        };
        /**
         * Create a new circle
         */
        _this.onCreateCircle = function () {
            var circleName = _this.state.circleName;
            if (circleName && circleName.trim() !== '') {
                _this.props.createCircle(_this.state.circleName);
                _this.setState({
                    circleName: '',
                    disabledCreateCircle: true
                });
            }
        };
        /**
         * Handle change group name input to the state
         */
        _this.handleChangeName = function (event) {
            _this.setState({
                circleName: event.target.value,
                disabledCreateCircle: (event.target.value === undefined || event.target.value.trim() === '')
            });
        };
        _this.handleSelectCircle = function (event, isInputChecked, circleId) {
            var _a = _this.props, userBelongCircles = _a.userBelongCircles, circles = _a.circles, setSelectedCircles = _a.setSelectedCircles, selectedCircles = _a.selectedCircles, userId = _a.userId;
            var newSelectedCircles = selectedCircles;
            if (isInputChecked) {
                newSelectedCircles = selectedCircles.push(circleId);
            }
            else {
                var circleIndex = selectedCircles.indexOf(circleId);
                newSelectedCircles = newSelectedCircles.remove(circleIndex);
            }
            setSelectedCircles(userId, newSelectedCircles);
            _this.setState({
                disabledDoneCircles: !_this.selectedCircleChange(newSelectedCircles)
            });
        };
        /**
         * Create a circle list of user which belong to
         */
        _this.circleList = function () {
            var _a = _this.props, circles = _a.circles, userId = _a.userId, userBelongCircles = _a.userBelongCircles, selectedCircles = _a.selectedCircles, classes = _a.classes;
            var circleDomList = [];
            if (circles) {
                circles.forEach(function (circle, circleId) {
                    var isBelong = selectedCircles ? selectedCircles.indexOf(circleId) > -1 : false;
                    // Create checkbox for selected/unselected circle
                    circleDomList.push(React.createElement(ListItem, { key: circleId + "-" + userId, dense: true, className: classes.listItem },
                        React.createElement(ListItemText, { className: classes.circleName, primary: circle.get('name') }),
                        React.createElement(ListItemSecondaryAction, null,
                            React.createElement(Checkbox, { onChange: function (event, isInputChecked) { return _this.handleSelectCircle(event, isInputChecked, circleId); }, checked: isBelong }))));
                });
                return circleDomList;
            }
        };
        /**
         * Check if the the selected circles changed
         */
        _this.selectedCircleChange = function (selectedCircles) {
            var isChanged = false;
            var _a = _this.props, userBelongCircles = _a.userBelongCircles, circles = _a.circles;
            if (selectedCircles.count() === userBelongCircles.count()) {
                for (var circleIndex = 0; circleIndex < selectedCircles.count(); circleIndex++) {
                    var selectedCircleId = selectedCircles.get(circleIndex);
                    if (!(userBelongCircles.indexOf(selectedCircleId) > -1)) {
                        isChanged = true;
                        break;
                    }
                }
            }
            else {
                isChanged = true;
            }
            return isChanged;
        };
        var _a = _this.props, userBelongCircles = _a.userBelongCircles, circles = _a.circles, userId = _a.userId;
        // Defaul state
        _this.state = {
            /**
             * The value of circle input
             */
            circleName: "",
            /**
             * It will be true if the text field for adding group is empty
             */
            disabledCreateCircle: true,
            /**
             * The button of add user in a circle is disabled {true} or not {false}
             */
            disabledAddToCircle: true,
            /**
             * Whether current user changed the selected circles for referer user
             */
            disabledDoneCircles: true,
        };
        // Binding functions to `this`
        _this.handleChangeName = _this.handleChangeName.bind(_this);
        _this.onCreateCircle = _this.onCreateCircle.bind(_this);
        _this.handleDoneAddCircle = _this.handleDoneAddCircle.bind(_this);
        _this.circleList = _this.circleList.bind(_this);
        _this.capitalize = _this.capitalize.bind(_this);
        return _this;
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    UserBoxComponent.prototype.render = function () {
        var _this = this;
        var disabledDoneCircles = this.state.disabledDoneCircles;
        var _a = this.props, isFollowed = _a.isFollowed, firstBelongCircle = _a.firstBelongCircle, belongCirclesCount = _a.belongCirclesCount, followRequest = _a.followRequest, userId = _a.userId, isSelecteCirclesOpen = _a.isSelecteCirclesOpen, addToCircleRequest = _a.addToCircleRequest, deleteFollowingUserRequest = _a.deleteFollowingUserRequest, classes = _a.classes, translate = _a.translate;
        var name = this.capitalize(this.props.fullName);
        return (React.createElement(Paper, { key: userId, elevation: 1, className: classNames('user', 'grid-cell', classes.paper) },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    height: '100%',
                    position: 'relative',
                    paddingTop: 20
                } },
                React.createElement("div", { style: { top: '0px', position: 'absolute', width: '100%', height: '47%', backgroundSize: 'cover', backgroundImage: "url(" + this.props.banner + ")" } }),
                React.createElement("div", { onClick: function () { return _this.props.goTo("/profile/" + _this.props.userId); }, style: { cursor: 'pointer' } },
                    React.createElement(UserAvatar, { fullName: name, fileName: this.props.avatar, size: 100 })),
                React.createElement("div", { onClick: function () { return _this.props.goTo("/profile/" + _this.props.userId); }, className: 'people__name', style: { cursor: 'pointer' } },
                    React.createElement("div", { className: 'userbox_name', style: { wordWrap: 'break-word' } },
                        name,
                        this.props.HTVerified ?
                            React.createElement("img", { style: { paddingLeft: '5px', maxWidth: '38px', maxHeight: '22px', display: 'inline-block', verticalAlign: 'bottom' }, src: 'https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/Check-01.png?alt=media&token=8f847073-5c3b-4350-ab15-3db65b0ba2be' })
                            : React.createElement("div", null))),
                React.createElement("div", { style: this.styles.followButton },
                    React.createElement(Button, { color: 'primary', onClick: this.onFollowUser, disabled: (followRequest ? followRequest.status === ServerRequestStatusType.Sent : false) ||
                            (deleteFollowingUserRequest ? deleteFollowingUserRequest.status === ServerRequestStatusType.Sent : false) }, !isFollowed ? translate('userBox.followButton')
                        : (belongCirclesCount > 1 ? translate('userBox.numberOfCircleButton', { circlesCount: belongCirclesCount }) : ((firstBelongCircle) ? firstBelongCircle.get('name', 'Followed') : translate('userBox.followButton')))))),
            React.createElement(Dialog, { PaperProps: { className: classes.fullPageXs }, key: this.props.userId || 0, open: isSelecteCirclesOpen === true, onClose: this.onRequestCloseAddCircle },
                React.createElement(DialogContent, { className: classes.dialogContent },
                    React.createElement(List, null,
                        this.circleList(),
                        React.createElement("div", { className: classes.space }),
                        React.createElement(Divider, null),
                        React.createElement(ListItem, { key: "'circleName'-" + userId, dense: true, className: classes.listItem },
                            React.createElement(ListItemText, { primary: React.createElement(TextField, { autoFocus: true, placeholder: translate('userBox.groupNamePlaceholder'), onChange: this.handleChangeName, value: this.state.circleName }) }),
                            React.createElement(ListItemSecondaryAction, null,
                                React.createElement(IconButton, { onClick: this.onCreateCircle, disabled: this.state.disabledCreateCircle },
                                    React.createElement(Tooltip, { title: translate('userBox.createCircleTooltip') },
                                        React.createElement(SvgAdd, null))))))),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { color: 'primary', disableFocusRipple: true, disableRipple: true, onClick: this.onRequestCloseAddCircle, style: { color: grey[800] } }, translate('userBox.cancelButton')),
                    React.createElement(Button, { color: 'primary', disableFocusRipple: true, disableRipple: true, disabled: disabledDoneCircles || (addToCircleRequest ? addToCircleRequest.status === ServerRequestStatusType.Sent : false), onClick: this.handleDoneAddCircle }, translate('userBox.doneButton'))))));
    };
    /**
     * Fields
     */
    UserBoxComponent.propTypes = {
        /**
         * User identifier
         */
        userId: PropTypes.string,
        /**
         * User information
         */
        user: PropTypes.object
    };
    return UserBoxComponent;
}(Component));
export { UserBoxComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        createCircle: function (name) { return dispatch(circleActions.dbAddCircle(name)); },
        addUserToCircle: function (circleIds, user) { return dispatch(circleActions.dbUpdateUserInCircles(circleIds, user)); },
        followUser: function (circleId, userFollowing) { return dispatch(circleActions.dbFollowUser(circleId, userFollowing)); },
        deleteFollowingUser: function (followingId) { return dispatch(circleActions.dbDeleteFollowingUser(followingId)); },
        setSelectedCircles: function (userId, circleList) { return dispatch(circleActions.setSelectedCircles(userId, circleList)); },
        removeSelectedCircles: function (userId, circleList) { return dispatch(circleActions.removeSelectedCircles(userId)); },
        openSelectCircles: function (userId) { return dispatch(circleActions.openSelectCircleBox(userId)); },
        closeSelectCircles: function (userId) { return dispatch(circleActions.closeSelectCircleBox(userId)); },
        goTo: function (url) { return dispatch(push(url)); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid']);
    var request = state.getIn(['server', 'request']);
    var circles = state.getIn(['circle', 'circleList'], {});
    var userBelongCircles = state.getIn(['circle', 'userTies', ownProps.userId, 'circleIdList'], ImuList());
    var isFollowed = userBelongCircles.count() > 0;
    var followingCircle = circles
        .filter(function (followingCircle) { return followingCircle.get('isSystem', false) && followingCircle.get('name') === "Following"; })
        .toArray()[0];
    var followRequestId = StringAPI.createServerRequestId(ServerRequestType.CircleFollowUser, ownProps.userId);
    var followRequest = state.getIn(['server', 'request', followRequestId]);
    var addToCircleRequestId = StringAPI.createServerRequestId(ServerRequestType.CircleAddToCircle, ownProps.userId);
    var addToCircleRequest = state.getIn(['server', 'request', addToCircleRequestId]);
    var deleteFollowingUserRequestId = StringAPI.createServerRequestId(ServerRequestType.CircleDeleteFollowingUser, ownProps.userId);
    var deleteFollowingUserRequest = state.getIn(['server', 'request', deleteFollowingUserRequestId]);
    var selectedCircles = state.getIn(['circle', 'selectedCircles', ownProps.userId], []);
    var isSelecteCirclesOpen = state.getIn(['circle', 'openSelecteCircles', ownProps.userId], []);
    var userBox = state.getIn(['user', 'info', ownProps.userId]);
    var Profile = state.getIn(['user', 'info', ownProps.userId]);
    return {
        translate: getTranslate(state.get('locale')),
        isSelecteCirclesOpen: isSelecteCirclesOpen,
        userName: Profile.userName,
        isFollowed: isFollowed,
        selectedCircles: selectedCircles,
        circles: circles,
        followingCircle: followingCircle,
        userBelongCircles: userBelongCircles,
        followRequest: followRequest,
        belongCirclesCount: userBelongCircles.count() || 0,
        firstBelongCircle: userBelongCircles ? circles.get(userBelongCircles.get(0), Map({})) : Map({}),
        avatar: userBox.avatar || '',
        banner: userBox.banner || 'https://media.giphy.com/media/f4pMuyoZwE5QQ/giphy.gif',
        fullName: userBox.fullName || '',
        HTVerified: userBox.HTVerified || false
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserBoxComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/userBox/UserBoxComponent.tsx
// module id = 1451
// module chunks = 0 1 2 3 10